module.exports = "https://static.wmbcdn.com/uniweb/images/7fb39dce94fe524b0da5791aea9ef0b4.svg";